import useSaveLocation from '../useSaveLocation';
import useCities from '../useCities';

export default function useAgroSaveLocationParams() {
  const { saveLocation } = useSaveLocation();
  const { cities } = useCities();

  const saveLocationParams = ({
    group,
    locationName,
    method,
    lat,
    lon,
    city,
  }) => {
    if (
      method === 'latlon'
    ) {
      const latNum = parseFloat(lat);
      const lonNum = parseFloat(lon);
      if (!Number.isNaN(latNum) && !Number.isNaN(lonNum)) {
        saveLocation(group, locationName, latNum, lonNum, undefined);
      }
    }
    if (
      method === 'predef'
      && (city)
    ) {
      const name = cities
        ?.find((c) => c.id === city)
        ?.label;
      saveLocation(group, name, undefined, undefined, city);
    }
  };

  return {
    saveLocationParams,
  };
}
